import {createTheme} from "@mui/material/styles";

const theme = createTheme({
    typography: {
        fontFamily: "Inter, Roboto, Arial, sans-serif",
        h1: {
            fontSize: "3.5rem",
            fontWeight: 700,
            lineHeight: 1.2,
            letterSpacing: "-0.01562em",
        },
        h2: {
            fontSize: "1.8rem",
            fontWeight: 600,
            lineHeight: 1.3,
            letterSpacing: "-0.00833em",
            fontFamily: "Figtree, sans-serif",
        },
        h3: {
            fontSize: "1.4rem",
            fontWeight: 500,
            lineHeight: 1.4,
            letterSpacing: "0em",
            fontFamily: "Figtree, sans-serif",
        },
        h4: {
            fontSize: "1.1rem",
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: "0.00735em",
        },
        h5: {
            fontSize: "1.25rem",
            fontWeight: 700,
            lineHeight: 1.6,
            letterSpacing: "0em",
        },
        h6: {
            fontSize: "1rem",
            fontWeight: 700,
            lineHeight: 1.7,
            letterSpacing: "0.0075em",
        },
        subtitle1: {
            fontSize: "1.5rem",
            fontWeight: 500,
            lineHeight: 1.75,
            letterSpacing: "0.00938em",
        },
        subtitle2: {
            fontSize: "0.875rem",
            fontWeight: 500,
            lineHeight: 1.57,
            letterSpacing: "0.00714em",
        },
        body1: {
            fontSize: "1rem",
            fontWeight: 400,
            lineHeight: 1.5,
            letterSpacing: "0.00938em",
        },
        body2: {
            fontSize: "0.875rem",
            fontWeight: 400,
            lineHeight: 1.43,
            letterSpacing: "0.01071em",
        },
        button: {
            textTransform: "none",
            fontWeight: 500,
            fontSize: "1rem",
            letterSpacing: "0.02857em",
        },
        caption: {
            fontSize: "0.75rem",
            fontWeight: 400,
            lineHeight: 1.66,
            letterSpacing: "0.03333em",
        },
        overline: {
            fontSize: "0.75rem",
            fontWeight: 400,
            lineHeight: 2.66,
            letterSpacing: "0.08333em",
            textTransform: "uppercase",
        },
    },
    components: {
        MuiDivider: {
            styleOverrides: {
                root: {},
            },
        },
    },
    palette: {
        primary: {
            main: "#1976d2", // Replace with your desired primary color
        },
        secondary: {
            main: "#dc004e", // Replace with your desired secondary color
        },
    },
});

export default theme;
